import { useState, useCallback, useEffect } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const CAROUSEL_IMAGES = [
  { src: "/IMG_1855.jpg", alt: "Radon mitigation installation 1" },
  { src: "/IMG_1857.jpg", alt: "Radon mitigation installation 2" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_zarc-chat-fork/artifacts/vipqfqtr_IMG_0727.jpeg", alt: "Radon mitigation installation 3" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_zarc-chat-fork/artifacts/tg5c11zg_IMG_7587.jpeg", alt: "Radon mitigation installation 4" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_zarc-chat-fork/artifacts/3wej97cp_IMG_8086.jpeg", alt: "Radon mitigation installation 5" },
];

export default function PastWorkCarousel() {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setCanScrollPrev(emblaApi.canScrollPrev());
    setCanScrollNext(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
    return () => emblaApi.off("select", onSelect);
  }, [emblaApi, onSelect]);

  return (
    <section className="py-12 px-4 sm:px-6 lg:px-8 bg-gray-50" data-testid="past-work-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">Our Past Work</h2>
          <p className="text-lg text-gray-600">Professional radon mitigation installations</p>
        </div>
        <div className="relative w-full" role="region" aria-roledescription="carousel">
          <div className="overflow-hidden" ref={emblaRef}>
            <div className="flex -ml-4">
              {CAROUSEL_IMAGES.map((img) => (
                <div key={img.src} role="group" aria-roledescription="slide" className="min-w-0 shrink-0 grow-0 basis-full pl-4">
                  <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                    <img alt={img.alt} className="w-full h-[500px] object-cover" src={img.src} />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <Button
            variant="outline"
            className="absolute h-8 w-8 rounded-full top-1/2 -translate-y-1/2 left-4 p-0"
            onClick={() => emblaApi?.scrollPrev()}
            disabled={!canScrollPrev}
            data-testid="carousel-prev-btn"
          >
            <ArrowLeft className="h-4 w-4" />
            <span className="sr-only">Previous slide</span>
          </Button>
          <Button
            variant="outline"
            className="absolute h-8 w-8 rounded-full top-1/2 -translate-y-1/2 right-4 p-0"
            onClick={() => emblaApi?.scrollNext()}
            disabled={!canScrollNext}
            data-testid="carousel-next-btn"
          >
            <ArrowRight className="h-4 w-4" />
            <span className="sr-only">Next slide</span>
          </Button>
        </div>
      </div>
    </section>
  );
}
